import { LogBuilder } from '@sgme/logger';

import { getConfig } from '@/config/config.ts';
import { sgwtConnect } from '@/sgwt/sgwtConnect.ts';

export const logger = buildLogger();

function buildLogger() {
  const logger = import.meta.env.DEV ? buildDevLogger() : buildProductionLogger();

  function onUserConnected(): void {
    logger.resumeServerLogs();
  }

  function onUserDisconnected(): void {
    logger.pauseServerLogs();
  }

  sgwtConnect.on('authorizationDiscarded', onUserDisconnected);
  sgwtConnect.on('authorizationExpired', onUserDisconnected);
  sgwtConnect.on('renewAuthorizationError', onUserDisconnected);
  sgwtConnect.on('renewAuthorizationSuccess', onUserConnected);

  return logger;
}

function buildProductionLogger() {
  return LogBuilder()
    .enableConsole({ minLevel: 'WARN' })
    .enableServerLogs({
      storeName: 'main',
      url: `${getConfig().app.apiUrl}api/log`,
      // TODO: remove if we can differentiate Fx from Forex via the Application header
      prefix: '[forex] ',
    })
    .setAuthTokenFactory(() => {
      if (sgwtConnect.isAuthorized()) {
        const authToken = sgwtConnect.getAuthorizationHeader();
        if (authToken) {
          return authToken;
        }
      }

      throw new Error('No authorization header or token. Disconnected ?!');
    })
    .build();
}

function buildDevLogger() {
  return LogBuilder().enableConsole({ minLevel: 'WARN' }).build();
}
